<template>
  <button :type="buttonType" :class="assembledClass"><slot></slot></button>
</template>

<script>
  export default {    
    props: {
      type: {
        type: String,
        default: 'primary'
      },      
      cls: {
        type: String,
        default: ''
      },
      animated: {
        type: Boolean,
        default: false
      },
      animatedIcon: {
        type: String,
        default: ''
      }
    },
    data: () => ({      
      assembledClass: ''
    }),
    created() {
      this.$watch('cls', (value) => {
        this.assembledClass = this.getClass();
      });
    },
    mounted() {
      this.initialize();      
    },
    computed: {
      buttonType() {
        return this.isSubmit() ? 'submit' : 'button'
      },
    },
    methods: {
      initialize() {
        // this.buttonType = this.isSubmit() ? 'submit' : 'button';
        this.assembledClass = this.getClass();
      },      
      isSubmit() {
        if (this.$el !== undefined && this.$el.attributes !== undefined) {            
          return this.$el.attributes.getNamedItem('submit') !== null;
        } else
          return false;
      },
      isBlock() {        
        if (this.$el !== undefined && this.$el.attributes !== undefined) 
          return this.$el.attributes.getNamedItem('block') !== null;
        else
          return false;
      },
      getClass() {
        const classes = [ 'btn', `btn-${this.type}` ];        
        if (this.isBlock()) classes.push('btn-block');
        if (this.animated) classes.push(`btn-animated from-left pg pg-check`);
        if (this.cls.length > 0) classes.push(this.cls);
        return classes.join(' ');
      }
    },
  }
</script>


// WEBPACK FOOTER //
// button.vue?a47ec80a